import { HStack, Text } from '@chakra-ui/react';
import { formatCoordinatesToString } from '@utils/validation/coordinates.utils';
import DmsCoordinates from 'dms-conversion';
import { FormattedMessage } from 'react-intl';

import { CoordinatesUnitEnum } from '@/types/commons/commons.types';

type CoordinatesBarProps = {
  coordinatesDMS: DmsCoordinates;
  handleUnitChange: (s: string) => void;
  unit: CoordinatesUnitEnum;
  backgroundColor?: string;
};

function CoordinatesBar({
  coordinatesDMS,
  handleUnitChange,
  unit,
  backgroundColor = 'neutral.800-op70',
}: Readonly<CoordinatesBarProps>) {
  const unitValues = Object.values(CoordinatesUnitEnum);
  const currentIndex = unitValues.indexOf(unit);

  const handleClick = () => {
    const nextIndex = (currentIndex + 1) % unitValues.length;
    handleUnitChange(unitValues[nextIndex]);
  };

  return (
    <HStack
      gap={2}
      width="100%"
      height={{ base: '32px', '4k': '40px' }}
      backgroundColor={backgroundColor}
      paddingX={2}
      paddingY={0.25}
      cursor="pointer"
      onClick={handleClick}
    >
      <Text marginLeft="auto" color="neutral.300">
        <FormattedMessage id={`common.units.${unit}`} />
      </Text>
      <Text width="100%">{formatCoordinatesToString(coordinatesDMS, unit as CoordinatesUnitEnum)}</Text>
    </HStack>
  );
}

export default CoordinatesBar;
